export class LoggedInUser {
    public id: number;
    public first_name: string;
    public last_name: string;
    public email: string;
    public company_id: number;
    public raws_per_page_chart_dashboard: number;
    public preferred_strongo_department_id: number | null;
    public companyName: string;
    public companyCode: string;
    public companyBlockedInErp: boolean;
    public image_data: string|null;
    public isVendor:boolean;
    public isCustomer:boolean;
    public isDeveloper:boolean;
    public hasDomesticRoadOrderEntry:boolean;
    public hasInternationalRoadOrderEntry:boolean;
    public hasStrongoOrderEntry:boolean;
    // KLG address-validation pilot: which provider the order-entry address form talks to.
    public usesKlgAddressValidation:boolean;
    public image_contents:string;
    public image_type:string;
    public lastReleaseRead:any|null;
    public au: LoggedInAdminUser|null;

    constructor(data: LoggedInUserData | undefined = undefined) {
        if (data === undefined) {
            this.id = 0;
            this.first_name = "";
            this.last_name = "";
            this.email = "";
            this.company_id = 0;
            this.raws_per_page_chart_dashboard = 3;
            this.preferred_strongo_department_id = null;
            this.companyName = "";
            this.companyCode = "";
            this.companyBlockedInErp = false;
            this.isVendor = false;
            this.isCustomer = false;
            this.isDeveloper = false;
            this.hasDomesticRoadOrderEntry = false;
            this.hasInternationalRoadOrderEntry = false;
            this.hasStrongoOrderEntry = false;
            this.usesKlgAddressValidation = false;
            this.image_contents = '';
            this.image_type = '';
            this.image_data = null;
            this.lastReleaseRead = null;
            this.au = null;

        } else {
            this.id = data.id;
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.email = data.email;
            this.company_id = data.company_id;
            this.raws_per_page_chart_dashboard = data.raws_per_page_chart_dashboard;
            this.preferred_strongo_department_id = data.preferred_strongo_department_id ?? null;
            this.companyName = data.companyName;
            this.companyCode = data.companyCode;
            this.companyBlockedInErp = data.companyBlockedInErp;
            this.isVendor = data.isVendor;
            this.isCustomer = data.isCustomer;
            this.isDeveloper = data.isDeveloper;
            this.hasDomesticRoadOrderEntry = data.hasDomesticRoadOrderEntry;
            this.hasInternationalRoadOrderEntry = data.hasInternationalRoadOrderEntry;
            this.hasStrongoOrderEntry = data.hasStrongoOrderEntry;
            this.usesKlgAddressValidation = data.usesKlgAddressValidation ?? false;
            this.image_contents = data.image_contents;
            this.image_type = data.image_type;
            this.image_data = null;
            if(data.image_data !== null)
            {
                this.image_data = data.image_data;
            }
            this.lastReleaseRead = null;
            if(data.lastReleaseRead !== null)
            {
                this.lastReleaseRead = data.lastReleaseRead;
            }
            this.au = null;
            if (data.au !== null) {
                this.au = new LoggedInAdminUser(data.au);
            }
        }
    }

    getInitials(glue: boolean | undefined): string | Array<string> {
        if (typeof glue === "undefined") {
            glue = true;
        }

        let full_name = this.getFullName();

        const initials = full_name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

        if (initials === null) {
            if (glue) {
                return "";
            } else {
                return [];
            }
        }

        if (glue) {
            return initials.join('');
        }

        return initials;
    };

    getFullName(): string {
        return `${this.first_name} ${this.last_name}`;
    }

    getProfilePicture(): string | null {
        return `data:${this.image_type};base64,${this.image_contents}`;
    }
}


export type LoggedInUserData = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    companyBlockedInErp: boolean;
    isVendor: boolean;
    isCustomer: boolean;
    isDeveloper: boolean;
    hasDomesticRoadOrderEntry: boolean;
    hasInternationalRoadOrderEntry: boolean;
    hasStrongoOrderEntry: boolean;
    usesKlgAddressValidation: boolean;
    image_contents: string;
    image_type: string;
    company_id: number;
    raws_per_page_chart_dashboard: number;
    preferred_strongo_department_id: number | null;
    companyName: string;
    companyCode: string;
    image_data: string | null;
    lastReleaseRead: any | null;
    au: LoggedInAdminUserData | null;
    accountPermissions: Array<string> | undefined;
}

export class LoggedInAdminUser {
    public first_name: string;
    public last_name: string;
    public email: string;
    public image_data: string | null;

    constructor(data: LoggedInAdminUserData | undefined = undefined) {
        if (data === undefined) {
            this.first_name = "";
            this.last_name = "";
            this.email = "";
            this.image_data = null;
        } else {
            this.first_name = data.first_name;
            this.last_name = data.last_name;
            this.email = data.email;
            this.image_data = data.image_data;
        }
    }

    getInitials(glue: boolean | undefined): string | Array<string> {
        if (typeof glue === "undefined") {
            glue = true;
        }

        let full_name = this.getFullName();

        const initials = full_name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);

        if (initials === null) {
            if (glue) {
                return "";
            } else {
                return [];
            }
        }

        if (glue) {
            return initials.join('');
        }

        return initials;
    };

    getFullName(): string {
        return `${this.first_name} ${this.last_name}`;
    }

}

export type LoggedInAdminUserData = {
    first_name: string;
    last_name: string;
    email: string;
    image_data: string | null;

}
